import { render, staticRenderFns } from "./consultingReply.vue?vue&type=template&id=65b51d52&"
import script from "./consultingReply.vue?vue&type=script&lang=js&"
export * from "./consultingReply.vue?vue&type=script&lang=js&"
import style0 from "./consultingReply.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports